import {
  LOGIN_REQUESTED,
  LOGOUT_REQUESTED,
  RESET_STORE,
} from 'containers/LoginPage/constants';

export const requestLogin = (user: any) => ({
  type: LOGIN_REQUESTED,
  payload: user,
});

export const requestLogout = () => ({
  type: LOGOUT_REQUESTED,
});

export const resetStore = () => ({
  type: RESET_STORE,
});
